module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-1-86ed0e3de701516070a4170649549c99.png";